import React from 'react'

import Aux from 'hoc/ReactAux/ReactAux'
import './Modal.css'
import ReactModal from 'react-modal'

const customStyles = {
  content: {
    background : 'none',
    border: 'none',
  },
  overlay : {
    zIndex                   : '9999999',
    width                    : '100%',
    height                   : '100%',
    left                     : '0',
    top                      : '0',
    backgroundColor         : 'rgba(0, 0, 0, 0.7)'
  }
}

const ModalSuccess = props => {
  if (!props.showModal) {
    return null
  }

  return (
    <Aux>
      <ReactModal
          isOpen={props.showModal}
          style={customStyles}
          onRequestClose={props.closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          contentLabel="Example Modal">
          <div id="lb-placed"
            style={props.style}
            className="lb-geral lb-placed_ mfp-bg-login white-popup-block lb-centralizar singup zoom-anim-dialog Modal-Success">
            <div className="lb-padrao-singup6 mfp-content-login modal-content">
              <button
                onClick={props.closeModal}
                type="button"
                className="bt-close mfp-close lb-fechar fa fa-times"
              />
              <div className="check-mark">
                <span className="fa fa-check-circle lt-success-tick" aria-hidden="true" />
              </div>
              <div className="lb-content">
                <span className="modal-success-description">
                  <strong>{props.message}</strong>
                </span>
                <a onClick={props.closeModal} className="bt">
                  Ok
                </a>
              </div>
            </div>
          </div>
      </ReactModal>
    </Aux>
  )
}

export default ModalSuccess



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalSuccess.js